/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_ProfileInputs */



/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Settings_Tab_ProfileInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_tab_profile = /** @type {((inputs?: Settings_Tab_ProfileInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_ProfileInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Profiel")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil")
	return /** @type {LocalizedString} */ ("Profile")
});